module.exports = __webpack_public_path__ + "img/22010____-26.prt.253ef275.jpg";